import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  control: {
    padding: '2px',
    marginRight: theme.spacing(1),
  },
  controlIcon: {
    width: '0.8em',
    height: '0.8em',
  },
  cellCheckbox: {
    paddingLeft: '7px',

    [theme.breakpoints.up('md')]: {
      paddingLeft: '15px',
    },
  },
  cellActions: {
    paddingRight: '7px',

    [theme.breakpoints.up('md')]: {
      paddingRight: '15px',
    },
  },
}));
